export const mfa = {
  // MFA Enrollment Page
  'mfa.enrollment.title': 'Activer l\'authentification à deux facteurs',
  'mfa.enrollment.subtitle': 'Ajoutez une couche de sécurité supplémentaire à votre compte',
  'mfa.enrollment.step': 'Étape',
  'mfa.enrollment.of': 'sur',
  'mfa.enrollment.complete': 'Terminé',

  // Step 1: Introduction
  'mfa.enrollment.intro.title': 'Sécurisez votre compte',
  'mfa.enrollment.intro.description': 'L\'authentification à deux facteurs (MFA) aide à protéger votre compte contre les accès non autorisés',
  'mfa.enrollment.intro.adminAlert.title': 'Compte administrateur détecté',
  'mfa.enrollment.intro.adminAlert.description': 'En tant qu\'administrateur, vous devez activer l\'authentification à deux facteurs pour accéder aux ressources protégées.',
  'mfa.enrollment.intro.step1.title': 'Téléchargez une application d\'authentification',
  'mfa.enrollment.intro.step1.description': 'Installez Google Authenticator, Microsoft Authenticator, Authy ou 1Password',
  'mfa.enrollment.intro.step2.title': 'Scannez le code QR',
  'mfa.enrollment.intro.step2.description': 'Utilisez votre application pour scanner le code QR que nous vous montrerons',
  'mfa.enrollment.intro.step3.title': 'Vérifiez la configuration',
  'mfa.enrollment.intro.step3.description': 'Entrez le code à 6 chiffres de votre application pour terminer la configuration',
  'mfa.enrollment.intro.cancel': 'Annuler',
  'mfa.enrollment.intro.getStarted': 'Commencer',
  'mfa.enrollment.intro.starting': 'Démarrage...',

  // Step 2: QR Code
  'mfa.enrollment.verify.title': 'Vérifier la configuration',
  'mfa.enrollment.verify.description': 'Entrez le code à 6 chiffres de votre application d\'authentification',

  // Step 3: Success
  'mfa.enrollment.success.title': 'C\'est prêt !',
  'mfa.enrollment.success.description': 'L\'authentification à deux facteurs est maintenant activée sur votre compte',
  'mfa.enrollment.success.alert.title': 'Votre compte est maintenant protégé',
  'mfa.enrollment.success.alert.description': 'Vous devrez entrer un code de votre application d\'authentification chaque fois que vous vous connectez. Assurez-vous de garder votre application d\'authentification accessible.',
  'mfa.enrollment.success.continue': 'Continuer vers le tableau de bord',

  // MFA Challenge Page
  'mfa.challenge.title': 'Authentification à deux facteurs',
  'mfa.challenge.subtitle': 'Entrez le code de vérification de votre application d\'authentification',
  'mfa.challenge.adminAlert.title': 'Vérification administrateur requise',
  'mfa.challenge.adminAlert.description': 'En tant qu\'administrateur, vous devez vérifier votre identité avec l\'authentification à deux facteurs pour accéder aux ressources protégées.',
  'mfa.challenge.factorTitle': 'Application d\'authentification',
  'mfa.challenge.factorDescription': 'Ouvrez votre application et entrez le code à 6 chiffres',
  'mfa.challenge.help.title': 'Vous ne pouvez pas accéder à votre application d\'authentification ?',
  'mfa.challenge.help.syncTime': 'Assurez-vous que l\'heure de votre appareil est synchronisée correctement',
  'mfa.challenge.help.correctApp': 'Vérifiez que vous utilisez la bonne application d\'authentification',
  'mfa.challenge.help.lostAccess': 'Contactez le support si vous avez perdu l\'accès à votre authentificateur',
  'mfa.challenge.help.codeRefresh': 'Le code se rafraîchit toutes les 30 secondes. Si vous l\'avez entré incorrectement, attendez un nouveau code.',
  'mfa.challenge.backToLogin': 'Retour à la connexion',

  // MFA QR Code Component
  'mfa.qrcode.title': 'Scanner le code QR',
  'mfa.qrcode.description': 'Ouvrez votre application d\'authentification et scannez ce code QR',
  'mfa.qrcode.manualSetup': 'Configuration manuelle',
  'mfa.qrcode.manualDescription': 'Si vous ne pouvez pas scanner le code QR, entrez ce code manuellement :',
  'mfa.qrcode.copySecret': 'Copier le secret',
  'mfa.qrcode.secretCopied': 'Secret copié !',
  'mfa.qrcode.recommendedApps': 'Applications recommandées',
  'mfa.qrcode.googleAuth': 'Google Authenticator',
  'mfa.qrcode.microsoftAuth': 'Microsoft Authenticator',
  'mfa.qrcode.authy': 'Authy',
  'mfa.qrcode.onePassword': '1Password',

  // MFA Code Input Component
  'mfa.codeInput.label': 'Code de vérification',
  'mfa.codeInput.placeholder': 'Entrez le code à 6 chiffres',
  'mfa.codeInput.verifying': 'Vérification...',
  'mfa.codeInput.verify': 'Vérifier',
  'mfa.codeInput.invalidCode': 'Code invalide. Veuillez réessayer.',

  // MFA Factor List Component
  'mfa.factorList.title': 'Authentificateurs enregistrés',
  'mfa.factorList.noFactors': 'Aucun authentificateur enregistré',
  'mfa.factorList.addFactor': 'Ajouter un authentificateur',
  'mfa.factorList.status.active': 'Actif',
  'mfa.factorList.status.verified': 'Vérifié',
  'mfa.factorList.enrolled': 'Enregistré',
  'mfa.factorList.remove': 'Supprimer',
  'mfa.factorList.confirmRemove.title': 'Supprimer l\'authentificateur',
  'mfa.factorList.confirmRemove.description': 'Êtes-vous sûr de vouloir supprimer cet authentificateur ? Vous devrez configurer MFA à nouveau pour accéder aux fonctionnalités d\'administration.',
  'mfa.factorList.confirmRemove.cancel': 'Annuler',
  'mfa.factorList.confirmRemove.confirm': 'Supprimer',

  // Loading & Auth States
  'mfa.loading.checkingAuth': 'Vérification de l\'authentification...',
  'mfa.loading.loadingFactors': 'Chargement des authentificateurs...',

  // Auth redirects
  'mfa.auth.loginRequired': 'Veuillez vous connecter pour activer l\'authentification à deux facteurs',
  'mfa.auth.loginToContinue': 'Veuillez vous connecter pour continuer',
} as const;
